import { render, staticRenderFns } from "./DriverInfo.vue?vue&type=template&id=a6d64e66&scoped=true"
import script from "./DriverInfo.vue?vue&type=script&lang=js"
export * from "./DriverInfo.vue?vue&type=script&lang=js"
import style0 from "./DriverInfo.vue?vue&type=style&index=0&id=a6d64e66&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d64e66",
  null
  
)

export default component.exports